import { storyblokEditable, type SbBlokData } from "@storyblok/react/rsc";

import { MediaElementStoryblok } from "@/generated/sb/sb-types";
import { Asset, sizes } from "../Asset";
import styles from "./sb-media.module.css";

const MediaElement = ({
  blok,
  restProps,
}: {
  blok: MediaElementStoryblok;
  restProps?: {
    pageOrder?: number;
  };
}) => {
  if (!blok) return <></>;
  return (
    <div
      data-blok
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className={styles.wrapper}
    >
      <Asset
        src={blok}
        sizes={sizes(100)}
        quality={90}
        audio={blok?.audio}
        muted={true}
        autoPlay
        loop={true}
        priority={restProps?.pageOrder === 1 ? true : undefined}
      />
    </div>
  );
};

export default MediaElement;
